import React from 'react'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import FormError from '~/Common-Objects/UI/Forms/FormError/FormError'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import TextArea from '~/Common-Objects/UI/Forms/TextArea/TextArea'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { connect } from 'react-redux'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import EmailTools from '~/Classes/emailValidator'
import i18n from '~/i18n'

@connect((store) => {
    return { user: store.user, account: store.accountMaster }
})
export default class IncGoAddGroup extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            newGroupData: {
                groupName: this.props.groupName || '',
                friendlyName: this.props.friendlyName || '',
                defaultFromName: this.props.defaultFromName || '',
                defaultFromEmailAddress: this.props.defaultFromEmailAddress || '',
                signupReminderText: this.props.signupReminderText || ''
            },
            errors: {
                groupName: '',
                friendlyName: '',
                defaultFromName: '',
                defaultFromEmailAddress: '',
                signupReminderText: ''
            },
            groupCreateError: '',
            charCount: 0,
            loading: false
        }

        this.updateValue = this.updateValue.bind(this)
        this.createGroup = this.createGroup.bind(this)
        this.closeDrawer = this.closeDrawer.bind(this)
        this.keyPress = this.keyPress.bind(this)
    }

    componentDidMount() {
        if (!this.props.defaultFromName || !this.props.defaultFromEmailAddress) {
            this.setState({ loading: true })
            fineDefaults(this.props.account.accountMaster.accountName)
                .then((defaults) => {
                    var newGroupData = this.state.newGroupData
                    if (!this.props.defaultFromName) {
                        newGroupData.defaultFromName = defaults.defaultFromName
                    }
                    if (!this.props.defaultFromEmailAddress) {
                        newGroupData.defaultFromEmailAddress = defaults.defaultFromEmailAddress
                    }
                    this.setState({ newGroupData: newGroupData, loading: false })
                })
                .catch(() => {
                    this.setState({ loading: false })
                })
        }
    }

    closeDrawer() {
        this.props.dispatch(siteMaster.alterSiteDrawer(false, false, 'right', null, true))
    }

    updateValue(evt) {
        var newGroupData = this.state.newGroupData
        if (
            evt.target.name === 'groupName' &&
            (!newGroupData.friendlyName || newGroupData.friendlyName === newGroupData.groupName)
        ) {
            newGroupData.friendlyName = evt.target.value
        }
        newGroupData[evt.target.name] = evt.target.value
        let charCount = this.state.charCount
        if (evt.target.name === 'signupReminderText') {
            charCount = evt.target.value.length
        }
        this.setState({ newGroupData: newGroupData, charCount: charCount })
    }

    keyPress(event) {
        if (event.key === 'Enter') {
            this.createGroup()
        }
    }

    createGroup() {
        var self = this
        var errors = {
            groupName: '',
            friendlyName: '',
            defaultFromName: '',
            defaultFromEmailAddress: '',
            signupReminderText: ''
        }
        var newGroupData = this.state.newGroupData

        var errored = false
        if (newGroupData.groupName.trim().length < 3) {
            errors.groupName = i18n.t('subscribers:index.alertName')
            errored = true
        }
        if (containsEmoji(newGroupData.signupReminderText)) {
            errors.signupReminderText = i18n.t('subscribers:index.alertReminderEmojis')
            errored = true
        }

        this.setState({ errors: errors })

        newGroupData.public = true
        newGroupData.defaultReplyAddress = newGroupData.defaultFromEmailAddress

        if (errored === false) {
            axios
                .post('/group', newGroupData)
                .then((groupDat) => {
                    self.props.addedGroup(groupDat)
                    if (!self.props.dontCloseDrawer) {
                        self.closeDrawer()
                    }
                })
                .catch((error) => {
                    console.log(error)
                    self.setState({
                        groupCreateError: error?.data?.error ? error.data.error.error : 'Error creating group'
                    })
                })
        }
    }
    render() {
        if (this.state.loading) {
            return <LoadingIcons />
        }
        return (
            <div>
                <h4 className='mar-b25'>{i18n.t('subscribers:index.addGroup')}</h4>
                <TextInput
                    outerClassName='mar-b25'
                    type='text'
                    name='groupName'
                    explainer={i18n.t('subscribers:index.nameDetails')}
                    label={i18n.t('subscribers:index.groupName')}
                    value={this.state.newGroupData.groupName}
                    onChange={this.updateValue}
                    error={this.state.errors.groupName}
                    focus={true}
                />
                <TextInput
                    outerClassName='mar-b25'
                    type='text'
                    name='friendlyName'
                    explainer={i18n.t('subscribers:index.friendlyDetail')}
                    label={i18n.t('subscribers:index.friendly')}
                    value={this.state.newGroupData.friendlyName}
                    onChange={this.updateValue}
                    error={this.state.errors.friendlyName}
                />
                <TextInput
                    outerClassName='mar-b25'
                    type='text'
                    name='defaultFromName'
                    explainer={i18n.t('subscribers:index.fromNameDetail')}
                    label={i18n.t('subscribers:index.fromName')}
                    value={this.state.newGroupData.defaultFromName}
                    onChange={this.updateValue}
                    error={this.state.errors.defaultFromName}
                />
                <TextInput
                    outerClassName='mar-b25'
                    type='email'
                    name='defaultFromEmailAddress'
                    explainer={i18n.t('subscribers:index.fromAddressDetail')}
                    label={i18n.t('subscribers:index.fromAddress')}
                    value={this.state.newGroupData.defaultFromEmailAddress}
                    onChange={this.updateValue}
                    error={this.state.errors.defaultFromEmailAddress}
                />
                <TextArea
                    outerClassName='mar-b25'
                    type='text'
                    name='signupReminderText'
                    explainer={i18n.t('subscribers:index.reminderTextDetail')}
                    label={i18n.t('subscribers:index.reminderText')}
                    value={this.state.newGroupData.signupReminderText}
                    onChange={this.updateValue}
                    error={this.state.errors.signupReminderText}
                    rows='5'
                    iconBottomRight={this.state.charCount + '/1500'}
                    maxLength={1500}
                />
                {this.state.groupCreateError && (
                    <FormError key={'err'} className='mar-b25'>
                        {this.state.groupCreateError}
                    </FormError>
                )}
                <Button
                    text={i18n.t('subscribers:index.addGroup')}
                    className='button-primary'
                    iconLeft={<Icons icon='plus' />}
                    onClick={this.createGroup}
                />
            </div>
        )
    }
}

function containsEmoji(str) {
    const emojiRegex = /(\p{Emoji_Presentation}|\p{Emoji}\uFE0F)/gu
    return emojiRegex.test(str)
}

async function fineDefaults(accountName) {
    const groups = (await axios.get('/group/simple')).data.Groups
    console.log(groups)
    // find the most common defaultFromName and defaultFromEmailAddress
    const nameCount = {}
    const emailCount = {}
    groups.forEach((group) => {
        if (group.defaultFromName) {
            nameCount[group.defaultFromName] = (nameCount[group.defaultFromName] || 0) + 1
        }
        if (group.defaultFromEmailAddress) {
            emailCount[group.defaultFromEmailAddress] = (emailCount[group.defaultFromEmailAddress] || 0) + 1
        }
    })
    let defaultFromName = ''
    if (Object.values(nameCount).every((c) => c <= 1)) {
        defaultFromName = accountName
    } else {
        defaultFromName = Object.keys(nameCount).reduce((a, b) => (nameCount[a] > nameCount[b] ? a : b), '')
    }
    const defaultFromEmailAddress = Object.keys(emailCount).reduce(
        (a, b) => (emailCount[a] > emailCount[b] ? a : b),
        ''
    )
    return { defaultFromName, defaultFromEmailAddress }
}
